module.exports = __webpack_public_path__ + "static/media/star-inactive.0b4f16f1.svg";